<template>
  <div class="subprogram-nba-rounds-table app-content-page">
    <el-table
      :class="{ 'el-table--simple': !isRegularSeasonConfigured }"
      v-if="rows && rows.length > 0"
      v-loading="loading"
      :data="rows"
      ref="table"
      row-key="id"
    >
      <!-- Name -->
      <el-table-column
        :label="i18n('entities.subprogram.nba.rounds.name')"
        min-width="30"
      >
        <template slot-scope="scope">
          <span v-text="roundName(scope.$index)"></span>
        </template>
      </el-table-column>

      <!-- Index -->
      <el-table-column
        :label="fields.hostingSchoolDivisionIndex.label"
        :prop="fields.hostingSchoolDivisionIndex.name"
        min-width="50"
        align="center"
      >
        <template slot-scope="scope">
          <span v-text="presenter(scope.row, 'hostingSchoolDivisionIndex')"></span>
        </template>
      </el-table-column>

      <!-- Start date -->
      <el-table-column
        :label="fields.startDate.label"
        :prop="fields.startDate.name"
        min-width="50"
      >
        <template slot-scope="scope">
          <span v-text="presenter(scope.row, 'startDate')"></span>
        </template>
      </el-table-column>

      <!-- End date -->
      <el-table-column
        :label="fields.endDate.label"
        :prop="fields.endDate.name"
        min-width="50"
      >
        <template slot-scope="scope">
          <span v-text="presenter(scope.row, 'endDate')"></span>
        </template>
      </el-table-column>

      <!-- Buttons -->
      <el-table-column
        v-if="isRegularSeasonConfigured"
        align="center"
        min-width="40"
      >
        <template slot-scope="scope">
          <div class="table-actions">
            <el-button
              @click="handleClickEdit(scope.row)"
              circle
              icon="icon-pen"
            />
            <el-button
              v-if="hasPermissionToDestroy"
              @click="doDestroyWithConfirm(scope.row.id)"
              circle
              icon="icon-trash"
            />
          </div>
        </template>
      </el-table-column>
    </el-table>
    <app-empty-page
      v-else
      v-loading="loading"
      :icon-class="'icon-calendar'"
      :empty-text="i18n('entities.subprogram.nba.rounds.empty')"
    /> 
  </div>
</template>

<script>
import { SubprogramRegularSeasonRoundsModel } from '@modules/subprogram/subprogram-regular-season-rounds-model';
import { mapActions, mapGetters } from 'vuex';
import { SubprogramPermissions } from '@modules/subprogram/subprogram-permissions';
import { get } from 'lodash';
import { i18n } from '@shared/i18n';

export default {

  name: 'app-subprogram-nba-rounds-table',

  props: {
    programId: String,
    subprogramId: String,
  isRegularSeasonConfigured: Boolean
  },

  data() {
    return {
      model: {}
    }
  },

  computed: {
    ...mapGetters({
      currentManage: 'auth/manage/currentManage',
      currentUser: 'auth/currentUser',
      rows: 'subprogram/nba/rounds/rows',
      loading: 'subprogram/nba/rounds/loading',
      dateFormat: 'auth/manage/dateFormat',
      populateDate: 'auth/manage/populateDate',
    }),
    
    hasPermissionToEdit() {
      return new SubprogramPermissions(this.currentUser).edit;
    },

    hasPermissionToDestroy() {
      return new SubprogramPermissions(this.currentUser)
        .destroy;
    },

    subpropertyId() {
      return get(this, 'currentManage.subproperty.id', null);
    },

    fields() {
      const { dateFormat, populateDate } = this;
      return new SubprogramRegularSeasonRoundsModel({
        dateFormat,
        populateDate,
      }).fields();
    },
  },

  async mounted() {

    return this.doFetchRound({
      subpropertyId: this.subpropertyId,
      programId: this.programId,
      subprogramId: this.subprogramId
    });
  },

  methods: {
    ...mapActions({
      doFetchRound: 'subprogram/nba/rounds/doFetchRound',
      doDestroyRound: 'subprogram/nba/rounds/doDestroyRound',
    }),

    presenter(row, fieldName) {
      const { dateFormat, populateDate } = this;
      return new SubprogramRegularSeasonRoundsModel({
        dateFormat,
        populateDate,
      }).presenter(row, fieldName);
    },

    handleClickEdit(row) {
      this.$router.push({
        name: `SubprogramRegularSeasonRoundsEdit`,
        params: {
          programId: this.programId,
          subprogramId: this.subprogramId,
          roundId: row.id
        }
      });
    },

    async doDestroyWithConfirm(id) {
      try {
        await this.$confirm(
          i18n('common.areYouSure'),
          i18n('common.confirm'),
          {
            confirmButtonText: i18n('common.yes'),
            cancelButtonText: i18n('common.no'),
            type: 'warning',
          },
        );

        // TODO: Destroy round function
        this.doDestroyRound({
          id,
          subprogramId: this.subprogramId,
          propertyId: this.propertyId,
          subpropertyId: this.subpropertyId,
          programId: this.programId,
        });
      } catch (error) {
        // no
      }
    },

    roundName(indexRound) {
      return i18n('entities.subprogram.nba.rounds.name')+' '+(indexRound+1);
    },

    i18n(code) {
      return i18n(code);
    },
  },
}
</script>

<style>
  .subprogram-nba-rounds-table .el-table__row {
    cursor: default;
  }
</style>